import { Controller } from "@hotwired/stimulus";

// Handles dynamic add/remove of nested form rows (e.g., call flow routes)
export default class extends Controller {
  static targets = ["template", "container"];

  add(event) {
    event.preventDefault();

    const template = this.templateTarget.innerHTML;
    const uniqueId = new Date().getTime();

    // Replace NEW_RECORD placeholder with unique timestamp ID
    const newRow = template.replace(/NEW_RECORD/g, uniqueId);

    this.containerTarget.insertAdjacentHTML("beforeend", newRow);
  }

  remove(event) {
    event.preventDefault();

    const row = event.target.closest("[data-nested-form-row]");

    if (row) {
      // If the row has a persisted record (has an id field with value), mark it for destruction
      const destroyField = row.querySelector("input[name*='_destroy']");

      if (destroyField) {
        destroyField.value = "1";
        row.style.display = "none";
      } else {
        // New unsaved row - just remove from DOM
        row.remove();
      }
    }
  }
}
